/* Page-only progressive disclosure. Original article text and links stay in the DOM. */
(() => {
  const root = document.querySelector('.ag-buy-rice--where-buy');
  const body = root?.querySelector('.ag-buy-rice__body');
  if (!body || body.dataset.guideReady) return;
  body.dataset.guideReady = 'true';
  const headings = [...body.querySelectorAll(':scope > h2')];
  if (headings.length) {
    const contents = document.createElement('details');
    contents.className = 'ag-buy-rice__contents';
    const summary = document.createElement('summary');
    summary.textContent = 'In this guide';
    summary.setAttribute('aria-expanded', 'false');
    summary.setAttribute('aria-controls', 'buy-rice-guide-links');
    const nav = document.createElement('nav');
    nav.id = 'buy-rice-guide-links';
    nav.setAttribute('aria-label', 'Organic rice buying guide sections');
    const list = document.createElement('ol');
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `buy-rice-section-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
    });
    nav.append(list);
    contents.append(summary, nav);
    contents.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(contents.open)));
    body.querySelector('.ag-buy-rice__byline')?.after(contents);
  }
  const faq = headings.find((heading) => /frequently asked questions/i.test(heading.textContent));
  if (!faq) return;
  let node = faq.nextElementSibling;
  let index = 0;
  while (node?.tagName === 'P' && node.querySelector('strong')) {
    const answer = node.nextElementSibling;
    if (answer?.tagName !== 'P' || answer.querySelector('strong')) break;
    const next = answer.nextElementSibling;
    index += 1;
    const item = document.createElement('div');
    item.className = 'ag-buy-rice__faq';
    const heading = document.createElement('h3');
    const button = document.createElement('button');
    button.type = 'button';
    button.id = `buy-rice-faq-question-${index}`;
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', `buy-rice-faq-answer-${index}`);
    button.append(...node.childNodes);
    heading.append(button);
    const panel = document.createElement('div');
    panel.id = `buy-rice-faq-answer-${index}`;
    panel.hidden = true;
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-labelledby', button.id);
    node.before(item);
    item.append(heading, panel);
    panel.append(answer);
    node.remove();
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      panel.hidden = !expanded;
    });
    node = next;
  }
})();
